module.exports = __webpack_public_path__ + "img/big-boxbg.8c7b7c07.png";